import { render, staticRenderFns } from "./NewLoan.vue?vue&type=template&id=3da4b77a&scoped=true"
import script from "./NewLoan.vue?vue&type=script&lang=js"
export * from "./NewLoan.vue?vue&type=script&lang=js"
import style0 from "./NewLoan.vue?vue&type=style&index=0&id=3da4b77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da4b77a",
  null
  
)

export default component.exports